(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("paypalLogos", [], factory);
	else if(typeof exports === 'object')
		exports["paypalLogos"] = factory();
	else
		root["paypalLogos"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 